import type { LocalAuditSession } from './types';

/**
 * Shared devices (store PCs; owner ruling 2026-10-18): a locally saved audit
 * belongs to the signed-in account that started it. Only that account sees
 * it in the Audits hub, opens it, syncs it, or clears it — someone else's
 * unsynced audit is never sent under the next person's name. It simply waits
 * on the device until its owner signs in again.
 */
export function sessionOwner(session: Pick<LocalAuditSession, 'ownerUpn' | 'auditorUpn'>): string {
  return (session.ownerUpn || session.auditorUpn || '').trim().toLowerCase();
}

export function ownsSession(
  session: Pick<LocalAuditSession, 'ownerUpn' | 'auditorUpn'>,
  signedInUpn: string | null | undefined,
): boolean {
  const me = (signedInUpn ?? '').trim().toLowerCase();
  return me !== '' && sessionOwner(session) === me;
}
